var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlaystoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24849 2.39844L13.7667 11.9148L16.2228 9.4587C12.8666 7.42242 8.37152 4.69077 6.34991 3.46258L4.99555 2.64208C4.75615 2.49624 4.49982 2.4177 4.24849 2.39844ZM2.7956 3.53783C2.77633 3.64239 2.75977 3.74747 2.75977 3.86029V22.6674C2.75977 22.7462 2.77563 22.8197 2.78664 22.8949L12.4696 13.2119L2.7956 3.53783ZM17.8369 10.4386L15.0637 13.2119L17.7886 15.9367C19.2323 15.0617 20.2323 14.454 20.3432 14.3871C20.834 14.0872 21.1111 13.6346 21.1028 13.1402C21.0955 12.655 20.8183 12.2212 20.3468 11.9542C20.2413 11.8937 19.255 11.2981 17.8369 10.4386ZM13.7667 14.5089L4.27716 23.9984C4.46152 23.9663 4.64566 23.9114 4.82177 23.805C5.06576 23.6564 11.657 19.6574 16.1744 16.9167L13.7667 14.5089Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlaystoreIcon);
export default __webpack_public_path__ + "static/media/google-playstore-icon.d5e8b2f4bd70b8e37515e8df1485e4cb.svg";
export { ForwardRef as ReactComponent };